const ADD_USER = '/users/create';
const REDIRECT_TO_HOME = '/';
export {
  ADD_USER,
  REDIRECT_TO_HOME,
};
